<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          class="d-flex flex-wrap justify-space-between"
        >
          <v-card
            class="pa-3"
            flat
          >
            <tw-cadastro-user
              @update="onUpdate"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="mr-2" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                  Cadastrar Usuário
                </v-btn>
              </template>
            </tw-cadastro-user>
          </v-card>
          <v-card
            class="pa-3 align-self-center"
            flat
          >
            <v-btn
              class="float-left"
              icon @click="getUsers">
              <v-icon center>mdi-refresh</v-icon>
            </v-btn>
            <tw-search-text
              label="Busque por um usuário"
              v-model="searchText"
              style="max-width: 400px; width: 350px;"
              :on-search="onChangeFilter"/>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="loading">
      <tw-circular-loading/>
    </div>
    <div v-if="!loading && (!users || !users.total)"
         align="center"
         class="headline mb-5 mt-10">
<!--      Nenhuma user encontrado.-->
      <v-spacer></v-spacer>
      <tw-cadastro-user
        @update="onUpdate"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="green"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Clique aqui cadastrar seu primeiro usuário
          </v-btn>
        </template>
      </tw-cadastro-user>
    </div>
    <div v-if="!loading && users && users.total">
      <v-row dense>
        <v-col>
          <v-list two-line subheader>
            <template v-for="user in users.content">
              <tw-user-item
                :key="user.id"
                :user="user"
                @update="onUpdate"
                @remove="onRemove"
              />
            </template>
          </v-list>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pagesLimit"
          :total-visible="8"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '@/api/user-service';
import UserItem from '@/modules/user/UserItem.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import CadastroUser from './CadastroUser.vue';

const LIMIT = 10;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data: () => ({
    page: PAGE,
    pagesLimit: 1,
    searchText: null,
    loading: false,
    users: {
      content: [],
      total: 0,
    },
    listOptions: {
      page: PAGE,
      limit: LIMIT,
      offset: 0,
      filter: '',
      sort: 'nome',
      sortDesc: false,
    },
    optionsList: {
      page: PAGE,
      itemsPerPage: LIMIT,
      sortBy: '',
      sortDesc: false,
      multiSort: false,
    },
  }),
  created() {
    this.getUsers();
  },
  methods: {
    buildSearchFilter(filters) {
      if (!filters.searchText) {
        return '';
      }
      return `(nome like "%${filters.searchText.toLowerCase()}%" or email like "%${filters.searchText.toLowerCase()}%" or telefone like "%${filters.searchText.toLowerCase()}%")`;
    },
    onChangeFilter() {
      this.listOptions.filter = this.buildSearchFilter({ searchText: this.searchText });
      this.resetPage();
      this.getUsers();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onUpdate() {
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      UserService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.users = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.users.total / LIMIT);
    },
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getUsers();
    },
    onRemove(item) {
      this.loading = true;
      UserService.remove(item.id)
        .then(() => {
          this.$toast('User removido com sucesso', { color: 'success' });
          this.getUsers();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    twCadastroUser: CadastroUser,
    twUserItem: UserItem,
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
};
</script>
